import * as React from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { ButtonGroup } from "affinityUI/form/components";

import { PatientFormLayout } from "./components/patientFormLayout";

export const PatientForm: React.FC = () => {
  return (
    <Card>
      <Form>
        <PatientFormLayout />
        <ButtonGroup>
          <NavigateButton variant={ButtonVariants.SECONDARY} to="../..">
            Cancel
          </NavigateButton>
          <ExecuteButton>Continue to confirmation</ExecuteButton>
        </ButtonGroup>
      </Form>
    </Card>
  );
};
